export default "__VITE_ASSET__BrjCZuKS__"